/**
 * @file 常量文件
 */
export const GLOBAL_SUPPLY_ID = '-9999';

export const knownSpiderMark = {
    'Baidu': [7010, 7019],
    'Google': [7020, 7029],
    '360': [7030, 7039],
    'Amazon': [7040, 7049],
    'Sougou': [7050, 7059],
    'Yisou': [7060, 7069],
    'Yandex': [7070, 7079],
    'Bing': [7090, 7090],
    'Apple': [7100, 7100],
    'Petal': [7110, 7110],
    '无头浏览器': [7800, 7999]
};

export const pvTypes = {
    '正常流量': [1000, 1000], // 单端流量
    '手机': [2000, 2999],
    'PC': [3000, 3999],
    '未知爬虫': [7000, 7000]
};

export const codeColors = {
    [GLOBAL_SUPPLY_ID]: '#357AFF'
};

export const colorSet = [
    '#46CEBB', '#FFC52F', '#AB7DF6'
];
